import { Injectable, ErrorHandler } from '@angular/core';
import * as Cookies from 'js-cookie';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, of, BehaviorSubject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { User } from '../_models/user';
import { Router } from '@angular/router';
import { ProductoService } from './producto.service';
import { LogingService } from './loging.service';
import extractDomain from 'extract-domain';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private currentUserSubject = new BehaviorSubject<User>(null);
  private domain = "." + extractDomain(window.location.hostname);
  public currentUser = this.currentUserSubject.asObservable();

  constructor(private http: HttpClient,
              private router: Router,
              private productoService: ProductoService,
              private logingService: LogingService) {
    if (this.isLogedIn()) {
      let usuario = {
        accessToken: Cookies.get('accessToken'),
        idToken: Cookies.get('currentUser'),
        refreshToken: Cookies.get('refreshToken'),
        tokenPermisos: null
      };
      this.currentUserSubject = new BehaviorSubject<User>(usuario);
      this.setUsuarioLoging(usuario);
    } else {
      // localStorage.clear();
    }
  }

  isLogedIn(): boolean {
    return Cookies.get('currentUser') != undefined && Cookies.get('currentUser') != '';
  }

  getcurrentUser(): User {
    return this.currentUserSubject.value;
  }

  getRefreshToken(): string {
    return this.getcurrentUser().refreshToken;
  }

  getIdToken(): string {
    return this.getcurrentUser().idToken;
  }

  getAccessToken(seguro: boolean = true): Observable<string> {
    if (!seguro) { return of(''); }
    const currentUser = this.getcurrentUser();
    if (currentUser == null || currentUser == undefined) { return of(''); }
    const accessToken = currentUser.accessToken;
    const helper = new JwtHelperService();
    if (helper.isTokenExpired(accessToken, 120)) {
      return this.refreshToken();
    }
    return of(accessToken);
  }

  updateUser(usr: User) {
    localStorage.setItem('currentUser', JSON.stringify(usr));
    this.currentUserSubject.next(usr);
    Cookies.set('currentUser', usr.idToken, {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    Cookies.set('accessToken', usr.accessToken, {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    Cookies.set('refreshToken', usr.refreshToken, {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    Cookies.set('tokenPermisos', usr.tokenPermisos?.tokenPermisos, {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
      Cookies.set('idToken', usr.idToken, {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    return usr;
  }

  private setUsuarioLoging(usr: User) {
    if(usr){
      const helper = new JwtHelperService();
      let tokenDecoded = helper.decodeToken(usr.idToken);
      console.log(tokenDecoded);
      this.logingService.addUserEmail(tokenDecoded.email);
    }
  }

  updateTokenPermisos(idAplicacion: any, tokenPermisos: string) {
    const usuario = this.getcurrentUser();
    usuario.tokenPermisos = {
      idProducto: idAplicacion,
      tokenPermisos
    };
    this.updateUser(usuario);
  }

  updateTokens(idToken: string, accessToken: string) {
    const usuario = this.getcurrentUser();
    usuario.idToken = idToken;
    usuario.accessToken = accessToken;
    this.updateUser(usuario);
  }

  logout() {
    localStorage.removeItem('currentUser');
    Cookies.remove('currentUser', {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    Cookies.remove('refreshToken', {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    Cookies.remove('accessToken', {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    Cookies.remove('tokenPermisos', {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    Cookies.remove('idToken', {
      sameSite: 'lax',
      path: '/',
      domain: this.domain
    });
    this.currentUserSubject.next(null);
  }

  esFederada() : Observable<boolean>{
    const helper = new JwtHelperService();
    return this.getAccessToken().pipe(map(ac => {
      const tokenDecode = helper.decodeToken(ac);
      return tokenDecode.username.indexOf("google_") !== -1 && tokenDecode.username.indexOf("office365_") !== -1
    }));
  }

  private refreshToken(): Observable<any> {
    const params = {
      token: Cookies.get('refreshToken')
    };
    return this.http.get<any>(`${environment.urlApi}api/v1/autenticacion/refrescarToken`, { params }).pipe(map(tokens => {
      const usuario = this.getcurrentUser();
      usuario.accessToken = tokens.accessToken;
      usuario.idToken = tokens.idToken;
      this.updateUser(usuario);
      return tokens.accessToken;
    }), catchError(err => {
      if (err.status == 401){
        this.logout();
        this.router.navigate(['/login', this.productoService.getCurrentApp()]);
      }
      return throwError(err);
  }));
  }
}
